import { render, staticRenderFns } from "./TimeDate.vue?vue&type=template&id=5156a0e2&scoped=true"
import script from "./TimeDate.vue?vue&type=script&lang=js"
export * from "./TimeDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5156a0e2",
  null
  
)

export default component.exports